import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1688 20.5H7.20215C5.54529 20.5 4.20215 19.1569 4.20215 17.5V6.5C4.20215 4.84315 5.54529 3.5 7.20215 3.5H18.2021C19.859 3.5 21.2021 4.84315 21.2021 6.5V12.5"
      stroke="#262626"
      stroke-width="2"
    />
    <path d="M8.20215 7.5H10.7021" stroke="#262626" stroke-width="2" stroke-linecap="round" />
    <circle cx="16.2021" cy="15" r="5.5" stroke="#262626" stroke-width="2" />
    <path d="M16.2021 15L16.2021 12.4999" stroke="#262626" stroke-width="2" stroke-linecap="round" />
    <path d="M16.2021 15H18.2021" stroke="#262626" stroke-width="2" stroke-linecap="round" />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.2002 6.5C2.2002 4.29086 3.99106 2.5 6.2002 2.5H17.2002C19.4093 2.5 21.2002 4.29086 21.2002 6.5V16.9826L15.5158 21.5H6.20019C3.99105 21.5 2.2002 19.7091 2.2002 17.5V6.5Z"
      fill="url(#paint0_linear_18903_5806)"
    />
    <path d="M7.2002 7.5H9.7002" stroke="white" stroke-width="2" stroke-linecap="round" />
    <circle cx="15.2002" cy="15" r="5.5" stroke="white" stroke-width="2" />
    <path d="M15.2002 15L15.2002 12.4999" stroke="white" stroke-width="2" stroke-linecap="round" />
    <path d="M15.2002 15H17.2002" stroke="white" stroke-width="2" stroke-linecap="round" />
    <defs>
      <linearGradient
        id="paint0_linear_18903_5806"
        x1="5.2002"
        y1="3.9976"
        x2="20.6746"
        y2="19.9968"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconTodo() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
